import { primaryColors } from '@assets/styles/helpers/colors.styles'

export const headerStyles = {
  zIndex: 6,
  backgroundColor: primaryColors.black,
  padding: '0.75rem 0',
  boxShadow: 'none'
}
